const Events = (function(window, $) {

    window.dataLayer = window.dataLayer || [];

    function Events() {}

    /**
     * Prepare product object for Enhanced Ecommerce event
     *
     * @param {Object} button An object representing a button.
     * @param {Object} productObj An object representing a product.
     * @returns {Object}
     */
    Events.createProduct = function(button, productObj) {
        let bookTitle, bookType, bookPrice, bookSerie, bookStock;

        if(button) {
            bookTitle = button.data('title');
            bookType = button.data('type');
            bookPrice = button.data('price');
            if (button.data('stock')) {
                bookStock = button.data('stock');
            }
            if (button.data('serie')) {
                bookSerie = button.data('serie');
            }
        }

        if (productObj.item_id) {
            productObj.item_id = parseInt(productObj.item_id);
            productObj.item_name = bookTitle;
            productObj.price = parseFloat(bookPrice);
            productObj.in_stock = bookStock ? 'in stock' : 'out of stock';

            // Due to inconsistencies in booktype modify the value contained with 'category'
            if (bookType) {
                productObj.item_category = bookType.toLowerCase().replace('-', '');
            }

            let parentEan = button.data('parent-ean') ?? productObj.item_id;

            // Add additional items
            let authors = $('[data-ean="' + parentEan + '"] [data-taxonomy="auteur"]').map(function() {return  $(this).data('taxonomy-term');}).get().join(" | ");
            if (authors) {
                productObj.item_category2 = authors;
            }

            let bookCat = $('[data-ean="' + parentEan + '"] [data-taxonomy="book_cat"], [data-taxonomy="genre"]').map(function() {return $(this).data('taxonomy-term');}).get().join(" | ");
            if (bookCat) {
                productObj.item_category3 = bookCat;
            }

            let ageCat = $('[data-ean="' + parentEan + '"] [data-taxonomy="age_cat"]').map(function() {return $(this).data('taxonomy-term');}).get().join(" | ");
            if (ageCat) {
                productObj.item_category4 = ageCat;
            }

            if (bookSerie) {
                productObj.item_category5 = bookSerie;
            }
        }

        return Object.assign(productObj, {
            quantity: 1,
            item_brand: $('meta[property="book:publisher"]').attr('content'),
            publisher: $('meta[property="og:site_name"]').attr('content') || window.location.hostname
        });
    };

    /**
     * Fire GA3 Ecommerce event
     *
     * @param {Object} productObj
     */
     Events.fireEcommerceEventGA3 = function(productObj) {
        window.dataLayer = window.dataLayer || [];
        // Old ua.js approach (keep for backwards GA3 compatibility)
        window.dataLayer.push({
            id: productObj.item_id,
            booktitle: productObj.item_name,
            booktype: productObj.item_category,
            price: productObj.price,
            currency: 'EUR',
            quantity: '1'
        });
    };

    /**
     * Fire Enhanced Ecommerce event
     *
     * @param {string} action eg. 'add', 'click', 'view' etc.
     * @param {Object} productObj
     * @param {string} eventName
     */
    Events.fireEcommerceEvent = function(action, productObj, eventName) {
        // Create event object with dynamic action
        let eventData = {
            'event': eventName,
            'ecommerce': {
                'currencyCode': 'EUR',
                [action]: [productObj]
            }
        };

        // Optional
        if (eventName) {
            eventData['event'] = eventName;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ecommerce: null}); // Clear the previous ecommerce object.
        window.dataLayer.push(eventData);
    };

    return Events;
}(window, jQuery));

export { Events };
